export default "__VITE_ASSET__4d4PH4a8__"